import { type } from 'os';
import notify from 'devextreme/ui/notify';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, model, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxDropDownBoxComponent, DxDropDownBoxModule, DxFileUploaderModule, DxFormModule, DxLookupModule, DxNumberBoxModule, DxPopupModule, DxProgressBarModule, DxScrollViewModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule, DxToastModule, DxTreeListComponent, DxTreeListModule, DxTreeViewModule, DxDropDownButtonModule, DxValidatorModule, DxLoadIndicatorModule, DxListModule, DxListComponent, DxToolbarModule, DxValidationGroupComponent, DxTooltipModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { DxiColumnModule, DxoValidationModule, DxiToolbarItemModule } from 'devextreme-angular/ui/nested';
import * as ExcelJS from 'exceljs';
import { ContactsAddCompanyComponent } from 'src/app/components/contacts-add-company/contacts-add-company.component';
import { ContactsAddPersonComponent } from 'src/app/components/contacts-add-person/contacts-add-person.component';
import { ContactsDropdownBoxComponent } from 'src/app/components/contacts-dropdown-box/contacts-dropdown-box.component';
import { ContactService } from 'src/app/services/contact.service';
import { SocietyService } from 'src/app/services/society.service';
import { ProjectTaskService } from 'src/app/services/project-task.service';
import { LoggingService } from 'src/app/services/logging.service';
import { TaskNotificationsPanelComponent } from 'src/app/components/task-notifications-panel/task-notifications-panel.component';
import { HolderSelectComponent } from 'src/app/components/holder-select/holder-select.component';
import { AppGlobals } from 'src/app/app.globals';
import { WikiService } from 'src/app/services/wiki.service';

import { TemplatesService } from 'src/app/services/templates.service';
import { TemplateManagementService } from 'src/app/services/template-management.service';
import { ProjectService } from 'src/app/services/project.service';
import { ProjectInfoService } from 'src/app/services/project-info.service';
import { GlobalPopupService } from 'src/app/components/generic-popup/presets/global-popup/global-popup.service';
import { ContactsPopupComponent } from 'src/app/components/contacts-popup/contacts-popup.component';
import { CommentsEditorComponent } from 'src/app/components/comment-editor/comment-editor.component';
import { DataAccessService } from 'src/app/services/data-access.service';
import { ConfigService } from 'src/app/services/config.service';
import { DocumentsService } from 'src/app/services/documents.service';
import { buildExportGapGroups, GapGroup, openTasksOf } from './export-gaps';

import { FileViewerOverlayService } from 'src/app/components/file-viewer-overlay/file-viewer-overlay.service';
import { getStatusOption, ProjectTaskStatusConfig, StatusData } from 'src/app/constants/Status';
import { StatusBoxComponent } from 'src/app/components/status-box/status-box.component';
import { PriorityPillComponent } from 'src/app/components/priority-pill/priority-pill.component';
import { PrioritiesConfig } from 'src/app/constants/Priority';
import { SharedPipesModule } from 'src/app/pipes/shared.pipes.module';
import { CommentService } from 'src/app/services/comment.service';
import { ContractService } from 'src/app/services/contracts/contract.service';
import { Subject, takeUntil } from 'rxjs';
import { FeatureFlags } from 'src/app/interfaces/enums/feature-flag';
import { ContractSelectorPopupComponent } from 'src/app/components/contract-selector-popup/contract-selector-popup.component';
import { StatusFilterComponent } from 'src/app/components/status-filter/status-filter.component';
import { StatusOption } from 'src/app/interfaces/status.model';
import { StatusPillComponent } from 'src/app/components/status-pill/status-pill.component';
import { ContactPillComponent, ContactPillValue } from 'src/app/components/contact-pill/contact-pill.component';
import { DocumentPillComponent } from 'src/app/components/document-pill/document-pill.component';
import { TaskStatusConfig } from 'src/app/constants/status-pill-configs';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { FileViewerComponent } from 'src/app/components/file-viewer/file-viewer.component';
import { ReasonService } from 'src/app/services/reason.service';
import { ReasonType, Reason } from 'src/app/interfaces/entities/reason';
import { GenericPopupComponent } from 'src/app/components/generic-popup/generic-popup.component';
import { ValueChangedEvent } from 'devextreme/ui/select_box';
import { FileViewerService } from 'src/app/services/file-viewer.service';
import { error } from 'console';
import { TaskTypeText } from 'src/app/pages/config/project-config/project-structure-config/project-task-config/datatypes-taskconfig';
import { AppConfig } from 'src/app/app.config';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { GpdPaginationComponent } from 'src/app/components/gpd-pagination/gpd-pagination.component';
import { GpdSegmentedSwitchComponent, SegmentOption } from 'src/app/components/gpd-segmented-switch/gpd-segmented-switch.component';
import { ProjectCompletePopupComponent } from 'src/app/components/project-complete-popup/project-complete-popup.component';
import { PopupButton } from '../../../../../components/generic-popup/generic-popup.component';
import { ProjectStatus } from '../../../../../interfaces/entities/project';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';

import { SearchableDropdownDirective } from '../../../../../directives/searchable-dropdown.directive';
import { GpdFilter } from 'src/app/components/gpd-filter/gpd-filter';
import { ProjectTaskListItem } from './project-tasks.types';
import { TaskTagsComponent } from 'src/app/components/task-tags/task-tags.component';
import {
  FillTemplateGeneratedDoc,
  fillTemplateFile,
  FillTemplateModalComponent,
} from 'src/app/components/fill-template-modal/fill-template-modal.component';
import { ApiFileService } from 'src/app/services/api-file.service';
@Component({
    selector: 'app-project-tasks',
    templateUrl: './project-tasks.component.html',
    styleUrls: ['./project-tasks.component.css'],
    providers: [ContactsAddCompanyComponent, ContactsAddPersonComponent, CommentsEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommentsEditorComponent,
        CommonModule,
        DxContextMenuModule,
        TaskNotificationsPanelComponent,
        HolderSelectComponent,
        DxDataGridModule,
        DxTreeViewModule,
        DxButtonModule,
        DxiColumnModule,
        DxTreeListModule,
        DxProgressBarModule,
        DxDateBoxModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxDropDownBoxModule,
        DxFileUploaderModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxPopupModule,
        DxTextAreaModule,
        DxValidatorModule,
        DxFormModule,
        DxSelectBoxModule,
        DxScrollViewModule,
        DxDropDownButtonModule,
        DxListModule,
        DxLoadIndicatorModule,
        DxAutocompleteModule,
        DxLookupModule,
        ContactsDropdownBoxComponent,
        DxToastModule,
        SharedPipesModule,
        ContactsPopupComponent,
        StatusBoxComponent,
        PriorityPillComponent,
        ContractSelectorPopupComponent,
        StatusFilterComponent,
        StatusPillComponent,
        TaskTagsComponent,
        DocumentPillComponent,
        ContactPillComponent,
        SvgIconComponent,
        DxTooltipModule,
        FileViewerComponent,
        DxiToolbarItemModule,
        GenericPopupComponent,
        DxoValidationModule,
        DxToolbarModule,
        GpdButtonComponent,
        GpdPaginationComponent,
        ProjectCompletePopupComponent,
        DxValidationGroupComponent,
        SearchableDropdownDirective, GpdFilter, FillTemplateModalComponent, GpdSegmentedSwitchComponent
    ]
})
export class ProjectTasksComponent implements OnInit {
  private readonly apiFileService = inject(ApiFileService);

  readonly taskStatusConfig = TaskStatusConfig;
  targetItem;

  type: any = '';
  message: any = '';
  toastTwoVisible: boolean = false;
  projectCompletePopupVisible = false;

  get currentUserName(): string {
    return AppGlobals.LoggedInUserData?.userName ?? '';
  }

  @ViewChild('taskList', { static: false }) taskList: DxTreeListComponent;

  @ViewChild('exportPackageList', { static: false })
  exportPackageList: DxListComponent;

  @ViewChild('companyGrid') companyGrid;
  @ViewChild('companyForm') companyForm;

  @ViewChild('personGrid') personGrid;
  @ViewChild('personForm') personForm;

  @ViewChild('commsFileInput') commsFileInput;

  @ViewChild('contactDropDownBox', { static: false })
  contactDropDownBox: DxDropDownBoxComponent;

  @ViewChild(CommentsEditorComponent) commentsEditor;
  @ViewChild(FileViewerComponent) fileViewerComponent: FileViewerComponent;

  ddbInstance: any;

  dataGridPersons: any;
  dataGridCompanies: any;

  projectId: any;
  projectStatus: string;
  stateStorageKey: string;

  expandedRowKeys: any[] = [];
  private expansionStateReady = false;
  private ganttNavActive = false;

  // "Phasen / Meilensteine / Arbeitspakete" switch (#4342): bulk-expands the tree to a
  // chosen hierarchy depth. 0 = only phases (nothing expanded, the default), 1 = expand
  // phases to reveal milestones, 2 = expand phases + milestones to reveal task packages,
  // 3 = expand task packages too, revealing the tasks.
  readonly expandOptions: SegmentOption[] = [
    { label: $localize`:@@taskListSwitchPhases:Phasen`, value: 0 },
    { label: $localize`:@@taskListSwitchMilestones:Meilensteine`, value: 1 },
    { label: $localize`:@@taskListSwitchPackages:Arbeitspakete`, value: 2 },
    { label: $localize`:@@taskListSwitchTasks:Aufgaben`, value: 3 },
  ];
  expandedLevel: number = 0;

  firstLoad = true;

  canExport = false;

  field;
  fieldType;

  now: Date;

  tasks = new Array();
  tasksCopy = new Array();

  taskCountByStatus: any;
  taskCountByStatusInitialFilter: any;

  states: any;

  statuses: any;

  TaskStatus = [];

  comments: any;

  noteText: any;
  notes = new Array();

  yesNo = [{ name: 'Ja' }, { name: 'Nein' }];

  statesComboBox = [
    StatusData.OPEN,
    StatusData.REJECTED,
    StatusData.NOT_REQUIRED,
    StatusData.DONE,
    StatusData.IN_REVIEW,
    StatusData.IN_PROGRESS,
  ];

  StatusData = StatusData;

  // The task row "..." menu (#4635). The menu is the entry point; picking an entry opens that
  // entry's popup, rather than the popup opening straight away as it used to.
  taskMenuVisible = false;
  taskMenuTarget = '';
  taskMenuTask: any = null;
  notesPopupVisible = false;
  historyPopupVisible = false;
  notificationsPopupVisible = false;

  @ViewChild('notificationsPanel') notificationsPanel?: TaskNotificationsPanelComponent;

  readonly closeButton: PopupButton[] = [
    { text: $localize`:@@close:Close`, icon: 'cancel', type: 'secondary', onClick: () => {} },
  ];

  readonly notificationButtons: PopupButton[] = [
    {
      text: $localize`:@@cancel:Cancel`,
      icon: 'cancel',
      type: 'secondary',
      // Staged additions live only in the panel, so cancelling means going back to what the task
      // actually has rather than just closing on top of them.
      onClick: () => void this.notificationsPanel?.load(),
    },
    {
      text: $localize`:@@confirm:Confirm`,
      icon: 'tick',
      // The popup stays open while the save runs, and closes itself only once it succeeded - a
      // rejected save has an error to show, and closing would throw it away.
      closeOnClick: false,
      onClick: () => void this.confirmNotifications(),
    },
  ];

  // Order follows the design (Kommentare / Verlauf / Benachrichtigungen), not #4635's wording,
  // which lists notifications second.
  // Per-task recipients are read by the notification platform alone, so the entry follows its
  // flag - with it off the panel would save rows nothing ever sends from.
  taskMenuItems: { id: string; text: string }[] = [
    { id: 'notes', text: $localize`:@@notes:Notes` },
    { id: 'info', text: $localize`:@@history:History` },
  ];

  private readonly notificationsMenuItem = {
    id: 'notifications',
    text: $localize`:@@notifications:Notifications`,
  };

  acitveFilter = {
    title: '',
    status: '',
  };

  persons: any;
  companies: any;
  contacts: any;

  popupSelectedTab = 0;

  contactsPopupVisible: boolean = false;
  editMode: boolean = false;

  selectedTaskId: any;

  newCountryId = 0;
  newPersonId = 0;

  searchTimer: any;

  contactsFilter: any;
  users: any;
  // #4994: the logged-in user's department (from GetListUsers), null when they have none.
  myDepartmentId: number | null = null;
  countries: string[] = [$localize`Germany`, $localize`Belgium`, $localize`France`];

  priorities: any = PrioritiesConfig.map(x => x.value);

  isGridBoxOpened = false;
  contactFilter: any;
  gridBoxValue: any;

  tmpFileStorage = null;
  documents = new Array();

  searchValue: any;
  searchFilter: any;
  stateFilter: any = null;
  filterStyle: any = null;

  // Debounce handle for the search box so typing does not re-filter on every keystroke.
  private searchDebounceTimer: any = null;
  // Cached per-status task counts for the toolbar pills. Angular change detection
  // re-evaluates getTaskCount() for every pill on every keystroke, so this avoids
  // repeated full scans of the task list. Invalidated whenever tasks (or their
  // statuses) change. null = needs rebuild.
  private taskCountCache: { all: number; [status: string]: number } | null = null;

  toastVisible = false;
  toastMessage = $localize`:@@savedSuccessfully:Saved successfully.`;

  taskId: any;

  loggingData = new Array();
  wikiArticlePopupVisible = false;

  article: any;
  note: any;

  noteFile: any;
  commsFiles: any;
  noteDescription: any;
  addMailMode: any = false;

  // "Aktuelle Aufgaben" filter dropdown (gpd-filter): both unchecked by default,
  // in this order per AC. Values: 'myTasks', 'currentTasks'.
  taskFilterOptions = [
    { value: 'myTasks', label: $localize`:@@myTasksCheckboxLabel:My Tasks`, subtitle: $localize`:@@myTasksSubtitle:Only tasks assigned to you.` },
    { value: 'currentTasks', label: $localize`:@@currentTasks:Current Tasks`, subtitle: $localize`:@@currentTasksSubtitle:Ongoing and overdue tasks.` },
  ];
  taskFilterValue = model<string[]>([]);

  currentSelectedRow: any;
  currentSelectedRowData: any = null;
  contractSelectorPopupVisible: boolean = false;

  siteId: number;
  contractTarget: any;

  currentPage: number = 1;
  totalPages: number = 1;
  itemsPerPage: number = 0;
  totalItems: number = 0;

  downloadDocumentOptions: any = [
    { value: -1, name: $localize`:@@export:Export`, icon: 'download' },
    {
      value: -2,
      name: $localize`:@@selectDocuments:Select Documents`,
      icon: 'document',
    },
    {
      value: -3,
      name: $localize`:@@selectCustomPackage:Select Custom Package`,
      icon: 'folder',
      onClick: () => {
        this.exportPackageSelectionPopupVisible = true;
      },
    },
  ];

  reopoenPopupButtons: PopupButton[];
  triggerRepaintEvent: boolean = true;

  Open: any = $localize`:@@open:Open`;
  Done: any = $localize`:@@done:Done`;
  Rejected: any = $localize`:@@rejected:Rejected`;
  Approved: any = $localize`:@@approved:Approved`;
  All: any = $localize`:@@all:All`;

  destinationPath: any = $localize`:@@destinationPath:Destination Path:`;

  WI: any = $localize`:@@wi:WI`;
  EPC: any = $localize`:@@epc:EPC`;
  Partner: any = $localize`:@@partner:Partner`;

  Gruppierung: any = $localize`:@@group:group`;
  Aufgabe: any = $localize`:@@task:task`;
  Datum: any = $localize`:@@date:date`;
  Dokument: any = $localize`:@@document:document`;
  JaNein: any = $localize`:@@yesNo:yes/no`;
  Kontakt: any = $localize`:@@contact:Contact`;
  Notiz: any = $localize`:@@note:note`;
  Nummer: any = $localize`:@@number:Number`;
  Text: any = $localize`:@@text:Text`;

  departments: any;

  exportPackages: any;
  exportPackageSelectionPopupVisible = false;

  allFilter: StatusOption = {
    value: { id: null, text: this.All },
    color: '',
    hashed: false,
  };
  filters = [this.allFilter].concat(ProjectTaskStatusConfig);

  contractsEnabled: boolean = false;
  private $unsubscribe = new Subject();

  previousStatus: any = null;
  reopenReasons: Reason[] = [];
  currentReopeningTask: any = null;
  selectedReopenReasonId: any = null;

  // #4658: a task that just moved to "In Review" and still needs a validator assigned
  validationTask: any = null;
  private validatorAssigned = false;
  // A validated DOCUMENT task asks for its reviewer before the file goes up, so cancelling leaves nothing behind
  private pendingValidatorUpload: (() => Promise<boolean>) | null = null;
  private pendingValidatorUploadCancelled: (() => void) | null = null;
  validationAssignee: string | null = null;
  validationPopupButtons: PopupButton[];
  validatorUsers: any[] = [];

  /** Header-filter options for the Tag column: only tags that occur in this list (#4810). */
  tagFilterDataSource: { text: string; value: number }[] = [];

  /** Plain text value - used by search, export and as the header filter's comparison base. */
  tagCellValue = (row: ProjectTaskListItem) => (row.tags ?? []).map(t => t.name).join(', ');

  /** A row matches a selected header-filter tag when it carries it; several selected tags OR together. */
  tagFilterExpression = (filterValue: any, _operation: string, target: string) => {
    if (target === 'headerFilter') {
      return [(row: ProjectTaskListItem) => (row.tags ?? []).some(t => t.id === filterValue), '=', true];
    }
    return [this.tagCellValue, 'contains', filterValue ?? ''];
  };

  typeLookup = Object.entries(TaskTypeText)
    .map(([id, val]) => ({ id, val }))
    .filter(x => x.id !== 'group');

  @ViewChild("statusVal") statusVal: DxValidationGroupComponent;
  @ViewChild("validationVal") validationVal: DxValidationGroupComponent;

  constructor(
    private societyService: SocietyService,
    private projectTaskService: ProjectTaskService,
    private contactService: ContactService,
    private activatedRoute: ActivatedRoute,
    private commentService: CommentService,
    private loggingService: LoggingService,
    private wikiService: WikiService,
    private templateService: TemplatesService,
    private templateManagementService: TemplateManagementService,
    private projectService: ProjectService,
    private appGlobals: AppGlobals,
    private dataAccessService: DataAccessService,
    private configService: ConfigService,
    private documentService: DocumentsService,
    private activityLog: ActivityLogService,
    private contractService: ContractService,
    private router: Router,
    private location: Location,
    private fileViewerService: FileViewerService,
    private reasonService: ReasonService,
    private projectInfoService: ProjectInfoService,
    private globalPopupService: GlobalPopupService
  ) {
    this.refreshTaskCommentCounter.bind(this);

    // Re-applies the task list filter (and re-derives pill counts) whenever the
    // "Meine Aufgaben" / "Aktuelle Aufgaben" checkboxes change, and persists the
    // new selection. Guarded on taskList existing: during initial state restore
    // (see initExpansionState()) this can fire before the tree-list view child
    // and its data source are ready.
    this.taskFilterValue.subscribe(() => {
      if (!this.taskList) return;
      this.applyFilter(true);
    });

    this.reopoenPopupButtons = [
      { text: $localize`:@@cancel:Cancel`, type: 'secondary', icon: 'cancel', onClick: () => this.onCancelReopenPopup() },
      { text: $localize`:@@save:Save`, type: 'primary', icon: 'tick', onClick: () => this.statusVal.instance.validate().isValid && this.onSaveReopenReason() },
    ];

    this.validationPopupButtons = [
      { text: $localize`:@@cancel:Cancel`, type: 'secondary', icon: 'cancel', onClick: () => (this.validationTask = null) },
      {
        text: $localize`:@@assign:Assign`,
        type: 'primary',
        icon: 'tick',
        closeOnClick: false,
        onClick: () => this.validationVal.instance.validate().isValid && this.onAssignValidator(),
      },
    ];
  }

  logItemData(item: any) {
    console.log('Item Data:', item);
  }

  getTaskTranlation(data) {
    if (!data?.type || data.type == 'group') return '';
    return TaskTypeText[data.type];
  }
  onDropDownBoxInit(e): void {
    this.ddbInstance = e.component;
  }

  ngOnInit(): void {
    this.TaskStatus = ProjectTaskStatusConfig;

    this.appGlobals.$features.pipe(takeUntil(this.$unsubscribe)).subscribe(() => {
      this.contractsEnabled = AppGlobals.UserCan(FeatureFlags.Contracts);
      //this.featureFlagsLoaded = true;
    });

    this.appGlobals.$features.pipe(takeUntil(this.$unsubscribe)).subscribe(() => {
      this.canExport = AppGlobals.UserCan(FeatureFlags.TaskPackageExport);
    });
    this.appGlobals.$features.pipe(takeUntil(this.$unsubscribe)).subscribe(() => {
      const enabled = AppGlobals.UserCan(FeatureFlags.Notifications);
      const listed = this.taskMenuItems.some((i) => i.id === this.notificationsMenuItem.id);

      if (enabled && !listed) this.taskMenuItems = [...this.taskMenuItems, this.notificationsMenuItem];
      else if (!enabled && listed)
        this.taskMenuItems = this.taskMenuItems.filter((i) => i.id !== this.notificationsMenuItem.id);
    });
    this.appGlobals.$features.pipe(takeUntil(this.$unsubscribe)).subscribe(() => {
      this.fillTemplateEnabled = AppGlobals.UserCan(FeatureFlags.AutomaticDocumentCreation);
      // #1205: "Fill in template" entry in the export dropdown, only while the flag is on
      const alreadyAdded = this.downloadDocumentOptions.some((o: any) => o.value === -4);
      if (this.fillTemplateEnabled && !alreadyAdded) {
        this.downloadDocumentOptions = [
          ...this.downloadDocumentOptions,
          { value: -4, name: $localize`:@@fillTemplate:Fill in template`, icon: 'edit' },
        ];
      } else if (!this.fillTemplateEnabled && alreadyAdded) {
        this.downloadDocumentOptions = this.downloadDocumentOptions.filter((o: any) => o.value !== -4);
      }
    });
    this.appGlobals.ShowGlobalLoader();
    this.projectId = this.activatedRoute.snapshot.params.id;
    this.activityLog.logView({ Section: ActivitySection.PROJECT_TASKS, ProjectId: Number(this.projectId) });
    this.stateStorageKey = `project-tasks-state-${this.projectId}`;

    this.taskId = this.activatedRoute.snapshot.params['taskId'];

    // Angular reuses this component when only route params change (same route config).
    // Subscribe to detect both project changes (full reload) and task-only changes (filter update).
    this.activatedRoute.params.pipe(takeUntil(this.$unsubscribe)).subscribe(params => {
      const newProjectId = params['id'];
      const newTaskId = params['taskId'];

      const projectChanged = newProjectId != null && newProjectId != this.projectId;
      const taskChanged = newTaskId != null && newTaskId != this.taskId;

      if (!projectChanged && !taskChanged) return;

      if (projectChanged) {
        // Different project — reload everything from scratch.
        this.projectId = newProjectId;
        this.stateStorageKey = `project-tasks-state-${this.projectId}`;
        this.taskId = newTaskId ?? null;
        this.searchValue = null;
        this.searchFilter = null;
        this.tasks = [];
        this.appGlobals.ShowGlobalLoader();
        this.getPageData().then(() => { this.appGlobals.HideGlobalLoader(); });
      } else if (taskChanged && this.tasks?.length > 0) {
        // Same project, different task — just update the search filter.
        this.taskId = newTaskId;
        const task = this.tasks.find(t => t.id == this.taskId);
        if (task?.title) {
          this.searchValue = task.title;
          this.searchFilter = ['title', 'contains', this.searchValue];
        }
        setTimeout(() => {
          this.search();
          this.applyFilter(true);
          this.taskList?.instance.refresh();
        });
      }
    });

    this.projectInfoService.getGlobalProjectInfo({ ProjectId: this.projectId }).then(result => {
      if (!result.hasError) this.projectStatus = result.globalProjectInfoResultItem?.status;
    });

    this.getUsers();
    this.getReopenReasons();

    this.getPageData().then(() => {
      this.appGlobals.HideGlobalLoader();
    });

    this.configService.getExportConfig({}).then(result => {
      this.exportPackages = result.exportConfigItems;
    });
  }

  ngOnDestroy(): void {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
    this.$unsubscribe.next(undefined);
    this.$unsubscribe.complete();
  }

  search(): void {
    let val = '';
    if (this.taskId != null) {
      const task = this.tasks.find(task => task.id == this.taskId);
      if (task?.title) {
        this.searchValueChanged({ value: task.title });
      }
    }
  }
  async getReopenReasons() {
    try {
      let result = await this.reasonService.getReasons({ type: ReasonType.TaskReopen });
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.reopenReasons = [
          ...result.reasons,
          { id: 0, name: $localize`:@@other:Other`, type: ReasonType.TaskReopen, isDeleted: false },
        ];
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }
  getUsers() {
    this.configService.getListOfUsers({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.users = result.projectsUsers;
          // #4994: tasks held by my department are mine too; re-filter once we know which it is.
          const me = AppGlobals.LoggedInUserData.email?.toLowerCase();
          this.myDepartmentId = this.users?.find(u => u.emailAddress?.toLowerCase() === me)?.departmentId ?? null;
          if (this.myDepartmentId != null && this.taskFilterValue().includes('myTasks')) this.applyFilter(true, true);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  private initExpansionState(): void {
    this.expansionStateReady = false;
    const comingFromGantt = !!(this.activatedRoute.snapshot.queryParams['packageId'] || this.activatedRoute.snapshot.queryParams['milestoneId']);
    const raw = localStorage.getItem(this.stateStorageKey);
    if (raw && !comingFromGantt) {
      const parsed = JSON.parse(raw);
      this.expandedRowKeys = parsed.expandedRowKeys ?? [];
      this.expandedLevel = parsed.expandedLevel ?? 0;
      if (parsed.taskFilterValue) {
        // Deferred like filterStyle below: the tree-list's data source needs a
        // change-detection cycle after `this.tasks` was just reassigned before
        // `.filter()` can act on it.
        setTimeout(() => this.taskFilterValue.set(parsed.taskFilterValue), 20);
      }
      if (parsed.filterStyle) {
        this.filterStyle = parsed.filterStyle;
        this.stateFilter = ['status', '=', parsed.filterStyle];
        setTimeout(() => this.applyFilter(false), 20);
      }
    } else {
      this.expandedRowKeys = [];
      this.expandedLevel = 0;
    }
    this.expansionStateReady = true;
  }

  private saveState(): void {
    if (this.ganttNavActive) return;
    localStorage.setItem(
      this.stateStorageKey,
      JSON.stringify({
        expandedRowKeys: this.expandedRowKeys,
        filterStyle: this.filterStyle ?? null,
        taskFilterValue: this.taskFilterValue(),
        expandedLevel: this.expandedLevel,
      })
    );
  }

  /**
   * "Phasen / Meilensteine / Arbeitspakete" switch handler (#4342): auto-expands the task
   * tree up to `level` (see expandOptions above) by collapsing every group row and then
   * re-expanding the ones shallower than the target — so rows exactly at `level` become
   * visible while staying collapsed themselves. "Aufgaben" (the last option) expands every
   * group regardless of depth: some trees nest tasks deeper than phase/milestone/package,
   * and a depth cut-off there left those tasks hidden.
   */
  setExpandLevel(level: number): void {
    this.expandedLevel = level;
    const expandAll = level === this.expandOptions[this.expandOptions.length - 1].value;
    const levelByTaskId = this.getTaskLevels();
    this.expandedRowKeys = this.tasks
      .filter(t => t.taskId && t.type === 'group' && (expandAll || (levelByTaskId.get(t.taskId) ?? 0) < level))
      .map(t => t.taskId);
    this.saveState();
  }

  // Depth of each task in the phase → milestone → task package → task hierarchy, derived
  // from the parentId chain (root nodes are depth 0). Memoized per call since it's only
  // needed when the level switch is clicked.
  private getTaskLevels(): Map<string, number> {
    const levels = new Map<string, number>();
    const byId = new Map<string, any>(this.tasks.filter(t => t.taskId).map(t => [t.taskId, t]));
    const visiting = new Set<string>();

    const resolve = (taskId: string): number => {
      if (levels.has(taskId)) return levels.get(taskId)!;
      // Guards against a cyclic parentId chain — shouldn't happen given how the backend
      // builds phase/milestone/task-package groups, but a self-referencing loop here would
      // otherwise recurse forever instead of just under-reporting that branch's depth.
      if (visiting.has(taskId)) return 0;
      visiting.add(taskId);
      const task = byId.get(taskId);
      const level = task?.parentId ? resolve(task.parentId) + 1 : 0;
      visiting.delete(taskId);
      levels.set(taskId, level);
      return level;
    };

    byId.forEach((_, taskId) => resolve(taskId));
    return levels;
  }

  onRowExpanded(e: any): void {
    if (!this.expansionStateReady) return;
    if (!this.expandedRowKeys.includes(e.key)) {
      this.expandedRowKeys = [...this.expandedRowKeys, e.key];
      this.saveState();
    }
  }

  onRowCollapsed(e: any): void {
    if (!this.expansionStateReady) return;
    this.expandedRowKeys = this.expandedRowKeys.filter(k => k !== e.key);
    this.saveState();
  }

  private buildTagFilterDataSource() {
    const byId = new Map<number, string>();
    for (const task of this.tasks ?? []) {
      for (const tag of task.tags ?? []) byId.set(tag.id, tag.name);
    }
    this.tagFilterDataSource = [...byId]
      .map(([value, text]) => ({ value, text }))
      .sort((a, b) => a.text.localeCompare(b.text));
  }

  async getTasks() {
    try {
      let result = await this.projectTaskService.getProjektAufgaben({
        WIProjectItem: { ProjectId: this.projectId },
      });
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.tasks = result.projectTasks;
        this.initExpansionState();

        for (let i = 0; i < result.projectTasks.length; i++) {
          try {
            if (result.projectTasks[i].taskResult !== undefined || result.projectTasks[i].taskResult !== null) {
              if (result.projectTasks[i].type === 'task') {
                result.projectTasks[i].taskResult = JSON.parse(result.projectTasks[i].taskResult);
                if (result.projectTasks[i].taskResult === null) {
                  result.projectTasks[i].taskResult = false;
                }
              }
              if (result.projectTasks[i].type === 'contact') {
                result.projectTasks[i].taskResult = JSON.parse(result.projectTasks[i].taskResult);
              }
            }
          } catch (error) {
            console.log('error parsing task result', error);
          }
        }
        this.tasks = result.projectTasks;
        this.buildTagFilterDataSource();

        const milestoneId = this.activatedRoute.snapshot.queryParams['milestoneId'];
        if (milestoneId) {
          const milestoneTaskId = `M-${milestoneId}`;
          const milestoneItem = this.tasks.find(t => t.taskId === milestoneTaskId);
          if (milestoneItem) {
            const keysToExpand: string[] = [milestoneTaskId];
            const collectDescendants = (parentId: string) => {
              this.tasks
                .filter(t => t.parentId === parentId && t.taskId)
                .forEach(child => {
                  keysToExpand.push(child.taskId);
                  collectDescendants(child.taskId);
                });
            };
            collectDescendants(milestoneTaskId);
            this.ganttNavActive = true;
            this.expandedRowKeys = [...new Set([...this.expandedRowKeys, ...keysToExpand])];
            this.location.replaceState(this.location.path().split('?')[0]);
            setTimeout(() => {
              this.taskList?.instance.navigateToRow(milestoneTaskId);
              setTimeout(() => { this.ganttNavActive = false; }, 100);
            }, 200);
          }
        }

        const packageId = this.activatedRoute.snapshot.queryParams['packageId'];
        if (packageId) {
          const packageTaskId = `TP-${packageId}`;
          const hasChildren = this.tasks.some(t => t.parentId === packageTaskId);
          if (!hasChildren) {
            notify($localize`:@@noTasksInPackage:This task package contains no tasks.`, 'info', 3000);
            this.location.replaceState(this.location.path().split('?')[0]);
            const savedRaw = localStorage.getItem(this.stateStorageKey);
            if (savedRaw) {
              const saved = JSON.parse(savedRaw);
              this.expandedRowKeys = saved.expandedRowKeys ?? [];
            }
          } else {
            const keysToExpand: string[] = [packageTaskId];
            let node = this.tasks.find(t => t.taskId === packageTaskId);
            while (node?.parentId) {
              keysToExpand.push(node.parentId);
              node = this.tasks.find(t => t.taskId === node!.parentId);
            }
            this.ganttNavActive = true;
            this.expandedRowKeys = [...new Set([...this.expandedRowKeys, ...keysToExpand])];
            this.location.replaceState(this.location.path().split('?')[0]);
            setTimeout(() => {
              this.taskList?.instance.navigateToRow(packageTaskId);
              setTimeout(() => { this.ganttNavActive = false; }, 100);
            }, 200);
          }
        }

        this.invalidateTaskCountCache();
        this.applyFilter(true);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  async getPageData() {
    this.appGlobals.ShowGlobalLoader();

    const promiseTaskList = this.getTasks();

    await Promise.all([
      this.contactService.getCompanies({}),
      this.contactService.getPersons({}),
      this.projectTaskService.getProjectTaskDocList({
        projectId: this.projectId,
      }),
      this.dataAccessService.getDepartments({}),
      promiseTaskList,
    ]).then(
      result => {
        if (result[0].hasError === true) AppGlobals.ShowErrorMessage(result[0].feedback);
        else {
          if (result[1].hasError === true) AppGlobals.ShowErrorMessage(result[1].feedback);
          else {
            if (result[2].hasError === true) AppGlobals.ShowErrorMessage(result[2].feedback);
            else {
              if (result[3].hasError === true) AppGlobals.ShowErrorMessage(result[3].feedback);

              if (this.taskId != undefined) {
                const task = this.tasks.find(task => task.id == this.taskId);
                if (task?.title) {
                  this.searchValue = task.title;
                  this.searchFilter = ['title', 'contains', this.searchValue];
                }
              }

              this.companies = result[0].companyItems;
              this.persons = result[1].personItems;
              this.contacts = this.companies.concat(this.persons);
              this.documents = result[2].docList;
              this.departments = result[3].departmentItems;
              this.appGlobals.HideGlobalLoader();
              setTimeout(() => {
                this.search();
                this.applyFilter(true);
                this.taskList.instance.refresh();
              });
            }
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    await this.loadLinkedContracts();

    this.appGlobals.HideGlobalLoader();
  }

  // ponytail: only the contracts already linked to CONTRACT tasks are needed here (for the
  // grid designation label). Picking a contract to complete a task loads the full list
  // lazily via ContractSelectorService when that popup opens.
  private async loadLinkedContracts(extraIds: number[] = []) {
    if (!this.contractsEnabled) return;

    const linkedContractIds = this.tasks
      .filter(t => t.type === 'contract' && t.taskResult != null && t.taskResult !== '')
      .map(t => Number(t.taskResult))
      .concat(extraIds)
      .filter(id => !isNaN(id));

    if (linkedContractIds.length) {
      await this.contractService.getContracts({ contractIds: [...new Set(linkedContractIds)] });
    }
  }

  validateNumber(e) {
    let regex = /^\d+(,\d+)?$/;

    if (e.data.type == 'number' && regex.test(e.value)) {
      return true;
    }
    if (e.data.type != 'number') {
      return true;
    }
  }

  commentsTaskId: number = 0;
  commentsEditorVisible: boolean = false;
  taskCommentCount: number = 0;

  refreshTaskCommentCounter(commentCount: number) {
    this.taskCommentCount = commentCount;
  }

  getProjectTaskComments(taskId) {
    this.commentsTaskId = taskId;
    this.commentsEditorVisible = false;

    this.taskCommentCount = 0;
    // comments	taskId
    this.projectService
      .getCommentCount({
        CommentArea: 'task',
        ProjectId: this.projectId,
        TaskId: taskId,
      })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.commentsEditorVisible = true;
            this.refreshTaskCommentCounter(result.commentCount);
            this.tasks.find(task => task.id == taskId).commentCount = result.commentCount;
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    return;
  }

  addComment(payload) {
    this.commentService.addProjectTaskComment({ commentItem: payload }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.getProjectTaskComments(payload.taskId);
          this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  onRowPrepared(e) {
    if (e.data != undefined) {
      if (e.level === 0) {
        e.rowElement.style.backgroundColor = 'var(--gt-background-color)';
        e.rowElement.style.fontWeight = '700';
        e.rowElement.style.color = 'black';
      }

      if (e.level === 1) {
        e.rowElement.style.backgroundColor = 'var(--gt-background-color)';
      }

      if (e.level === 2) {
        e.rowElement.style.backgroundColor = 'var(--gt-background-color)';
      }

      if (e.level >= 3) {
        e.rowElement.style.backgroundColor = 'var(--gt-background-color)';
      }

      if (e.data.type != 'group') e.rowElement.style.backgroundColor = '#ffffff';

      if (e.data.type === 'group') {
        if (this.filterStyle) {
          let hasChildren = false;

          if (e.node) {
            if (e.node.children) {
              hasChildren = e.node.children.length > 0;
              if (hasChildren === true) {
                let childrenVisible = false;

                for (let ci = 0; ci < e.node.children.length; ci++) {
                  if (e.node.children[ci].visible == true) childrenVisible = true;
                }

                if (childrenVisible === false) hasChildren = false;
              }
            }
          }

          if (hasChildren == false) {
            e.rowElement.style.display = 'none';
          }
        }
      }
    }
  }

  changeSelectedRow(e) {
    if (this.currentSelectedRowData != null && this.currentSelectedRow != null) {
      this.currentSelectedRow.style.backgroundColor = this.currentSelectedRowData.backupColor;
    }

    if (e.data.backupColor == null) e.data.backupColor = e.rowElement.style.backgroundColor;
    e.rowElement.style.backgroundColor = 'var(--color-secondary)';

    this.currentSelectedRow = e.rowElement;
    this.currentSelectedRowData = e.data;
  }

  onCellPrepared(e) {
    if (e.columnIndex == 0 && this.searchValue) {
      let title = e.displayValue;
      //let titleLower = title.toLowerCase().split(this.searchValue).join(searchMatchString);
      let index = title.toLowerCase().indexOf(this.searchValue.toLowerCase());
      if (index == -1) return;
      let match = title.slice(index, index + this.searchValue.length);
      var searchMatchString = "<span class='search-text'>" + match + '</span>';
      title = title.split(match).join(searchMatchString);

      var result = `<div class='title-container-wiki' > ${title} <div>`;

      if (e.cellElement?.querySelector('.dx-treelist-text-content') == null) return;

      if (e.data.helpLink != null) {
        let wikiElements = e.cellElement
          .querySelector('.dx-treelist-text-content')
          .getElementsByClassName('title-container-wiki-content');
        if (wikiElements != null && wikiElements.length > 0) {
          wikiElements[0].innerHTML = title;
        }
      } else e.cellElement.querySelector('.dx-treelist-text-content').innerHTML = result;
    }
  }

  handleExportButtonClick(e: any): void {
    if (e.itemData.value === -1) this.exportAsExcel(null);
    if (e.itemData.value === -2) this.loadDocumentDownloadData();
    if (e.itemData.value === -4) this.openFillTemplateForExport();

    if (e.itemData.value > 0) {
      this.getExportPackageData(e.itemData.value);
    }
  }

  calculateDisplayValue(rowData) {
    if (rowData.nr) {
      return `${rowData.nr} ${rowData.title}`;
    } else {
      return `${rowData.title}`;
    }
  }

  createTitle(rowData) {
    return `${rowData.nr} ${rowData.title}`;
  }

  clearStatusFilter() {
    this.stateFilter = null;
    this.filterStyle = null;
    this.taskList?.instance.filter(null);
    this.applyFilter(true);
  }

  filterByStatus(state: any) {
    if (state === null) {
      this.clearStatusFilter();
      return;
    }

    this.filterStyle = state;
    this.stateFilter = ['status', '=', state];
    this.applyFilter(false);
  }

  searchValueChanged(e) {
    this.searchValue = e.value;
    this.searchFilter = this.searchValue ? ['title', 'contains', this.searchValue] : null;

    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }

    // Clearing the box should feel instant; debounce real keystrokes so the tree
    // re-filters/re-renders once after typing pauses instead of on every letter.
    // Pass skipSave=true: a search changes neither expandedRowKeys nor filterStyle,
    // so there is nothing to persist.
    if (!this.searchValue) {
      this.applyFilter(true, true);
      return;
    }

    this.searchDebounceTimer = setTimeout(() => {
      this.searchDebounceTimer = null;
      this.applyFilter(true, true);
    }, 250);
  }

  applyFilter(updateCounters: boolean, skipSave: boolean = false) {
    // Pill counts are derived from search + "Meine Aufgaben" + "Aktuelle Aufgaben"
    // (see rebuildTaskCountCache), so any change to those three must invalidate the
    // cache. Status-pill-only changes (filterByStatus) pass updateCounters=false,
    // since which pill is selected never changes what the other pills count.
    if (updateCounters) {
      this.invalidateTaskCountCache();
    }

    let filter = new Array();

    if (this.searchFilter) {
      filter.push(this.searchFilter);
    }

    if (this.stateFilter) {
      if (filter.length > 0) {
        filter.push('and');
      }
      filter.push(this.stateFilter);
    }

    const taskFilterValue = this.taskFilterValue();

    if (taskFilterValue.includes('myTasks')) {
      if (filter.length > 0) {
        filter.push('and');
      }
      const mine = ['assignedUserEmail', '=', AppGlobals.LoggedInUserData.email];
      filter.push(this.myDepartmentId == null ? mine : [mine, 'or', ['assignedDepartmentId', '=', this.myDepartmentId]]);
    }

    if (taskFilterValue.includes('currentTasks')) {
      if (filter.length > 0) {
        filter.push('and');
      }
      filter.push(['isTaskPackageCurrentOrOverdue', '=', true]);
    }

    if (filter.length > 0) {
      this.taskList.instance.filter(filter);
    } else {
      this.taskList.instance.filter(null);
    }

    if (this.stateStorageKey && !skipSave) {
      this.saveState();
    }
  }

  sendNote() {
    this.notes.push(this.noteText);
    this.noteText = '';
  }

  // tasklist logic shenangans
  updateTaskCountByStatus(task) {
    if (task.projectTasks == null) return;
    if (task.projectTasks.length == 0) return;

    task.projectTasks.forEach(subtask => {
      this.updateTaskCountByStatus(subtask);
    });
  }

  completeTask(item) {
    if (item.taskResult != null && item.status == StatusData.IN_REVIEW.id) {
      item.status = StatusData.DONE.id;
      item.isCompleted = true;
      this.taskList.instance.refresh();
      this.saveItem(item).then(() => {
        this.cleanUrl();
      });
    }
  }

  updateStatus(item) {
    setTimeout(() => {
      console.log(item);
      const before = { status: item.status, isCompleted: item.isCompleted };
      if (item.taskResult === null) {
        item.taskResult = false;
      }
      if (item.taskResult === '' || item.taskResult === null || item.taskResult === false) {
        item.status = StatusData.OPEN.id;
        item.isCompleted = false;
      } else {
        if (
          item.requiresValidation != true ||
          item.requiresValidation === null ||
          item.requiresValidation === undefined
        ) {
          item.status = StatusData.DONE.id;
          item.isCompleted = true;
        } else {
          item.status = StatusData.IN_REVIEW.id;
          item.isCompleted = true;
        }
      }
      this.saveOrPromptForValidator(item, before);
    }, 50);
  }

  /**
   * #4880: a task only reaches "In Review" together with the person who will review it, so
   * the review notification (#4881) goes to them. When a reviewer is needed nothing is saved
   * until one is picked, and the row keeps showing `before` so it never reads "In Review"
   * without a reviewer; cancelling the prompt reloads the grid and the task stays as it was.
   */
  private saveOrPromptForValidator(item, before: { status: string; isCompleted: boolean }) {
    if (this.promptForValidatorIfNeeded(item, before)) return;

    this.saveItem(item).then(() => this.cleanUrl());
  }

  /**
   * #4658: prompt only when the task will genuinely sit in "In Review" waiting on
   * someone. Four ways it will not:
   *
   * - The current user can validate. ProjectTaskLogic auto-approves IN_REVIEW -> DONE
   *   for them on this very save ("Approve automatically if [...] the user has approval
   *   rights"), so the row lands on Done and a validator prompt would contradict it.
   * - The project is completed or paused. saveItem refuses those with its own warning,
   *   so a prompt would stack on top of a save that never happened.
   * - A prompt is already open. ponytail: one at a time — a second task keeps the old
   *   pre-#4658 behaviour rather than silently replacing the first prompt. Queue them
   *   if completing two validated tasks in one breath turns out to be a real workflow.
   * - Nobody on the list can validate. The prompt could only be cancelled, which would
   *   make the task impossible to submit; it is saved and the department holds the review.
   */
  private shouldPromptForValidator(item): boolean {
    return (
      item.status === StatusData.IN_REVIEW.id &&
      !AppGlobals.UserPermissions.canValidate &&
      this.projectAcceptsEdits &&
      this.validationTask == null &&
      this.candidateValidators().length > 0
    );
  }

  /** Mirrors the states saveItem refuses to write (it warns and reloads instead). */
  private get projectAcceptsEdits(): boolean {
    return (
      this.projectStatus !== ProjectStatus.COMPLETED &&
      this.projectStatus !== ProjectStatus.INACTIVE &&
      this.projectStatus !== ProjectStatus.CANCELED
    );
  }

  resetTaskResult(item, previousStatus = item.status) {
    const before = { status: previousStatus, isCompleted: item.isCompleted };
    if (item.status == StatusData.OPEN.id) {
      item.taskResult = item.type == 'task' ? 'false' : null;
      item.isCompleted = false;
    }
    if (item.isCompleted == null) item.isCompleted = false;
    this.closeEditCell();
    this.saveOrPromptForValidator(item, before);
  }

  changeStatus(e: ValueChangedEvent, item) {
    console.log('changeStatus', e, item);
    if (item.reopenRequiresReason == true) {
      this.previousStatus = e.previousValue;
      this.currentReopeningTask = item;
    } else {
      this.resetTaskResult(item, e.previousValue);
    }
  }

  tasksInTaskPackage(id) {
    let task = this.tasks.find(task => task.taskId == id);
    if (id > 0) {
      return this.tasksInTaskPackage(task.parentId);
    } else {
      let tasks = this.tasks.filter(task => task.parentId == id && task.type != 'group');
      let groups = this.tasks.filter(task => task.parentId == id && task.type == 'group');
      for (let group of groups) {
        tasks.push(this.tasks.filter(task => task.parentId == group.Id && task.type != 'group'));
      }
      return tasks;
    }
  }

  onSaveReopenReason() {
    this.currentReopeningTask.reopenId = this.selectedReopenReasonId;
    this.selectedReopenReasonId = null;
    this.resetTaskResult(this.currentReopeningTask, this.previousStatus);
    this.currentReopeningTask = null;
  }

  /**
   * #4883: only users who can actually approve the task, i.e. Validate and up on the
   * Heimdall rights ladder: View(1) Write(2) Complete(3) Validate(4) Delete(5).
   * ProjectTaskLogic refuses the approval from anyone below.
   */
  private candidateValidators(): any[] {
    return (this.users ?? []).filter((u: any) => u.canValidate === true);
  }

  /**
   * Opens the prompt if this task really is going to sit and wait. Returns whether it
   * did, in which case the save is left to onAssignValidator.
   *
   * Called from the two routes a user can put a task into "In Review" — completing it
   * (updateStatus) and picking the status straight off the grid dropdown (changeStatus
   * -> resetTaskResult). Deliberately NOT from saveItem itself: departmentChanged saves
   * too, and prompting there would re-prompt for the assignment just made.
   */
  private promptForValidatorIfNeeded(item, before: { status: string; isCompleted: boolean }): boolean {
    if (!this.shouldPromptForValidator(item)) return false;
    item.status = before.status;
    item.isCompleted = before.isCompleted;
    this.openValidatorPrompt(item);
    return true;
  }

  private openValidatorPrompt(item) {
    // Snapshot the list rather than recomputing it per change-detection pass; the popup
    // binds this array directly.
    this.validatorUsers = this.candidateValidators();
    // Only pre-select the current assignee if they may actually take it on.
    this.validationAssignee = this.validatorUsers.some(u => u.emailAddress === item.assignedUserEmail)
      ? item.assignedUserEmail
      : null;
    this.validationTask = item;
    this.validatorAssigned = false;
  }

  onAssignValidator() {
    const item = this.validationTask;
    this.validatorAssigned = true;
    this.validationTask = null;

    const upload = this.pendingValidatorUpload;
    this.pendingValidatorUpload = null;
    this.pendingValidatorUploadCancelled = null;

    if (upload) {
      item.assignedUserEmail = this.validationAssignee ?? null;
      item.assignedDepartmentId = null;
      void upload().then(uploaded => {
        if (!uploaded) return;
        item.status = StatusData.IN_REVIEW.id;
        item.isCompleted = true;
        return this.saveItem(item);
      });
      return;
    }

    item.status = StatusData.IN_REVIEW.id;
    item.isCompleted = true;
    // One save carries both the status and the reviewer; applyChangedTasks refreshes the grid cell
    this.departmentChanged(item, { email: this.validationAssignee ?? null, departmentId: null });
  }

  /**
   * Every close path (Assign, Later, the header X, Esc) ends here via dx-popup's
   * onHiding, so this is the one place the deferred cleanUrl belongs. It cannot run
   * on a timer while the prompt is open: `tasks` and `tasks/:taskId` are separate
   * routes, so cleanUrl destroys and recreates this component — which used to take
   * the prompt down with it about 2s after it appeared.
   */
  onValidatorPromptClosed() {
    this.validationTask = null;
    this.pendingValidatorUpload = null;
    this.pendingValidatorUploadCancelled?.();
    this.pendingValidatorUploadCancelled = null;

    if (this.validatorAssigned) {
      this.cleanUrl();
      return;
    }

    // The status change was never saved; reload so the grid shows the task as it still is.
    void this.getTasks().finally(() => this.cleanUrl());
  }

  onCancelReopenPopup() {
    this.currentReopeningTask.status = this.previousStatus;
    this.currentReopeningTask = null;
    this.previousStatus = null;
  }

  // Utility function to clean the URL
  cleanUrl() {
    const urlTree = this.router.parseUrl(this.router.url);
    const segments = urlTree.root.children['primary'].segments;
    if (segments.length > 0 && /^\d+$/.test(segments[segments.length - 1].path)) {
      segments.pop();
    }
    const newUrl = '/' + segments.map(s => s.path).join('/');
    this.router.navigateByUrl(newUrl);
  }

  uploadDocument(item, e) {
    const file = e.target.files[0];
    if (file.name.length > AppConfig.MaxFileNameLength) {
      AppGlobals.ShowErrorMessage(
        $localize`:@@fileNameTooLongError:File name is too long. Maximum allowed length is ${AppConfig.MaxFileNameLength}:maxLength: characters.`
      );
      e.target.value = '';
      return;
    }
    if (item.requiresValidation === true && this.shouldPromptForValidator({ ...item, status: StatusData.IN_REVIEW.id })) {
      this.pendingValidatorUpload = () => this.uploadTaskFile(item, file);
      this.openValidatorPrompt(item);
      return;
    }

    void this.uploadTaskFile(item, file).then(uploaded => uploaded && this.updateStatus(item));
  }

  private async uploadTaskFile(item, file: File): Promise<boolean> {
    const formData = new FormData();

    formData.append('projectId', this.projectId);
    formData.append('taskId', item.id);
    formData.append('fileBytes', file);
    formData.append('filename', file.name);

    try {
      const result = await this.projectTaskService.UploadTaskFile(formData);
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return false;
      }
      item.taskResult = result.id + '';
      this.documents.push({
        id: result.id,
        projectId: this.projectId,
        taskId: item.taskId,
        documentName: result.docName,
        displayName: result.docDisplayName,
        url: null,
        moveToSharepoint: result.movedToSharepoint,
      });
      return true;
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
      return false;
    }
  }

  /** Resolves to whether the task was actually written (#4658 callers chain off this). */
  async saveItem(item): Promise<boolean> {
    if (this.projectStatus === ProjectStatus.COMPLETED) {
      this.globalPopupService.showWarningPopup(this.completedProjectWarning);
      await this.getTasks();
      return false;
    }
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      await this.getTasks();
      return false;
    }

    let type = '';

    // let type = '';

    if (item.type == 'contact') {
      type = item.contactType;
    } else {
      type = null;
    }

    let payload: any = {
      projectId: Number(this.projectId),
      taskId: Number(item.id),
      contactType: type,
      taskResult: item.taskResult === false ? '' : item.taskResult != null ? item.taskResult + '' : null,
      taskNote: item.note,
      status: item.status,
      // department: item.departmentId,
      isCompleted: item.isCompleted,
      gridConnectionId: Number(this.siteId),
      internalReference: item.internalReference,
      priority: item.priority,
      assignedUserEmail: item.assignedUserEmail,
      assignedDepartmentId: item.assignedDepartmentId ?? null,
      reopenId: item.reopenId,
    };

    return this.projectTaskService.saveProjectTask({ ProjectTask: payload }).then(
      result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
          this.getPageData();
          return false;
        }
        this.projectService.triggerRefreshMilestones();
        this.applyChangedTasks(result.changedTasks);
        if (result.projectAutoCompleted) {
          this.projectCompletePopupVisible = true;
        } else if (result.projectAlmostCompleted) {
          this.globalPopupService.showPopup({
            title: $localize`:@@projectAlmostCompleteTitle:Project almost complete`,
            content: $localize`:@@projectAlmostCompleteTasksDone:You have completed the last task. However, there are still outstanding costs in the project. Please check these and settle the outstanding costs or delete costs that are no longer relevant.`,
            buttons: [{ text: $localize`:@@ok:Ok`, onClick: () => {}, type: 'secondary' }],
          });
        }
        return true;
      },
      () => {
        AppGlobals.ShowErrorMessage($localize`:@@internalServerError:Internal server error`);
        this.getPageData();
        return false;
      }
    );
  }

  private applyChangedTasks(changedTasks: any[]) {
    if (changedTasks?.length) {
      this.invalidateTaskCountCache(); // a task's status may have changed → pill counts are stale
      for (const changed of changedTasks) {
        const task = this.tasks.find(t => t.id === changed.id);
        if (task) {
          task.status = changed.status;
          task.priority = changed.priority;
          task.assignedUserEmail = changed.assignedUserEmail;
          task.assignedDepartmentId = changed.assignedDepartmentId;
          task.assignedDepartmentName = changed.assignedDepartmentName;

          task.contactType = changed.contactType;
          task.reopenRequiresReason = changed.reopenRequiresReason;

          try {
            if (task.taskResult !== undefined) {
              if (task.type === 'task') {
                changed.taskResult = JSON.parse(changed.taskResult ?? 'false');
              }
              if (task.type === 'contact' && changed.taskResult !== null) {
                changed.taskResult = JSON.parse(changed.taskResult);
              }
            }
          } catch (error) {
            console.log('error parsing task result', error);
          }
          task.taskResult = changed.taskResult;
        }
      }
    }
  }

  private getTaskPackageTaskId(task: any): string | null {
    if (!task?.parentId) return null;
    if (task.parentId.startsWith('TP-')) return task.parentId;
    const parent = this.tasks.find(t => t.taskId === task.parentId);
    return this.getTaskPackageTaskId(parent);
  }

  /** #4993: the holder picker hands over a person or a department; setting one clears the other. */
  departmentChanged(rowData: any, holder?: { email: string | null; departmentId: number | null }) {
    const item = rowData.data ?? rowData;
    if (holder) {
      item.assignedUserEmail = holder.email;
      item.assignedDepartmentId = holder.departmentId;
    }
    this.saveItem(item);
  }

  closeEditCell() {
    this.taskList.instance.closeEditCell();
  }

  // Status/priority editors only exist once their cell is clicked, so open the list straight
  // away - otherwise changing a value would take a second click.
  openEditorDropDown(e: { component: { open(): void } }) {
    setTimeout(() => e.component.open());
  }

  onDropdownContactSelected(e, item) {
    item.data.taskResult = e.data.id;
    item.data.contactType = e.type;
    this.updateStatus(item.data);
  }

  searchNodeById(element, id) {
    if (element.id == id) {
      return element;
    } else if (element.projectTasks != null) {
      var result = null;
      for (let i = 0; result == null && i < element.projectTasks.length; i++) {
        result = this.searchNodeById(element.projectTasks[i], id);
      }
      return result;
    }
    return null;
  }

  /* contact popup stuff */

  setPopupReturnTarget(item): void {
    this.targetItem = item;
  }

  onNewContactSelected(e) {
    this.targetItem.taskResult = e.id;
    this.targetItem.contactType = e.type;

    if (e.type == 'company') {
      this.contactService.getCompanies({}).then(result => {
        this.companies = result.companyItems;
        this.contactsPopupVisible = false;
        this.updateStatus(this.targetItem);
      });
    }

    if (e.type == 'person') {
      this.contactService.getPersons({}).then(result => {
        this.persons = result.personItems;
        this.contactsPopupVisible = false;
        this.updateStatus(this.targetItem);
      });
    }
  }

  onPopupContactSelected(e) {
    this.targetItem.taskResult = e.data.id;
    this.targetItem.contactType = e.type;
    this.contactsPopupVisible = false;
    this.updateStatus(this.targetItem);
  }

  showContactsPopup(id) {
    this.selectedTaskId = id;
    this.contactsPopupVisible = true;
  }

  /*
  async saveChanges(e) {
    if (this.tmpFileStorage.length != 0) {
      for (let file of this.tmpFileStorage) {
        var formData = new FormData();
        formData.append("projectId", this.projectId);
        formData.append("taskId", file.taskId);
        formData.append("fileBytes", file.file);
        formData.append("filename", file.file.name);
        try {
          const result = await this.projectTaskService.UploadTaskFile(formData);

          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
            return;
          }

          this.changedItems.find(
            (item) => item.taskId == file.taskId
          ).taskResult = result.id + "";
        } catch (error) {
          AppGlobals.ShowErrorMessage(error);
          return;
        }
      }

      this.projectTaskService
        .getProjectTaskDocList({ projectId: this.projectId })
        .then(
          (result) => {
            if (result.hasError === true)
              AppGlobals.ShowErrorMessage(result.feedback);
            else {
              this.documents = result.docList;
              this.projectTaskService
                .writeProjectTasks({ projectTasks: this.changedItems })
                .then(
                  (result) => {
                    if (result.hasError === true)
                      AppGlobals.ShowErrorMessage(result.feedback);
                    else {
                      this.saveToast({
                        type: true,
                        feedback: $localize`:@@saved:Saved`,
                      });
                      this.tmpFileStorage = [];
                      this.changedItems = [];
                      //this.getProjectTaskComments({ projectId: this.projectId, taskId: file.taskId });
                      this.getPageData();
                      this.toastVisible = true;
                      this.projectService.triggerRefreshMilestones();
                    }
                  },
                  (error: any) => {
                    AppGlobals.ShowErrorMessage(error);
                  }
                );
            }
          },
          (error: any) => {
            AppGlobals.ShowErrorMessage(error);
          }
        );
    } else {
      this.projectTaskService.getProjectTaskDocList({ projectId: this.projectId }).then((result) => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.documents = result.docList;
          this.projectTaskService.writeProjectTasks({ projectTasks: this.changedItems }).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
              this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
              //this.getProjectTaskComments({ projectId: this.projectId, taskId: this.selectedTaskId });
              this.tmpFileStorage = [];
              this.changedItems = [];
              this.getPageData();
              this.toastVisible = true;
              this.projectService.triggerRefreshMilestones();
            }
          },
            (error: any) => {
              AppGlobals.ShowErrorMessage(error);
            });
        }
      },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        });
    }
  }
  */

  getCompanyName(id) {
    if (id == '' || id == null || id == 'null') {
      return '';
    }

    if (this.companies !== undefined && this.companies !== null) {
      let company = this.companies.find(item => item.id == id);
      if (company != null) {
        return company.name;
      } else {
        return $localize`:@@companyNotFound:company not found`;
      }
    } else {
      return $localize`:@@companyNotFound:company not found`;
    }
  }

  getPersonName(id) {
    if (id == '' || id == null || id == 'null') {
      return '';
    }

    if (this.persons != undefined && this.persons !== null) {
      let person = this.persons.find(item => item.id == id);
      if (person != null) {
        // Either name field can be null; concatenating raw yields "null Meier" in the export.
        return `${person.firstname ?? ''} ${person.lastname ?? ''}`.trim();
      } else {
        return $localize`:@@personNotFound:person not found`;
      }
    } else {
      return $localize`:@@personNotFound:person not found`;
    }
  }

  getCompanyId() {
    return this.newCountryId - 1;
  }

  getPersonId() {
    return this.newPersonId - 1;
  }

  searchContact(item) {
    if (item.firstname != undefined) {
      return ['firstname', 'lastname'];
    }
    if (item.name != undefined) {
      return ['name'];
    }
  }

  dropDownBoxValueChanged(e) {
    clearTimeout(this.searchTimer);
    this.isGridBoxOpened = false;
  }

  isSearchIncomplete(dropDownBox) {
    // compare the last displayed value and the current real text in the input field
    let displayValue = dropDownBox.option('displayValue'),
      text = dropDownBox.option('text');
    text = text && text.length && text;
    displayValue = displayValue && displayValue.length && displayValue[0];
    return text !== displayValue;
  }

  onInput(e: any) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      let text = e.component.option('text'),
        opened = this.isGridBoxOpened;
      //this.dataSource.searchValue(text);
      if (opened && this.isSearchIncomplete(e.component)) {
        let filter = this.contactDropDownBox.instance.option('text');
        this.companyGrid.instance.filter(['name', 'contains', filter]);
        this.personGrid.instance.filter(['firstname', 'contains', filter], 'or', ['lastname', 'contains', filter]);
      } else {
        this.isGridBoxOpened = true;
      }
    }, 500);
  }

  companyGridOnInitialized(e: any) {
    this.companyGrid = e.component;
    setTimeout(() => {
      let filter = this.contactDropDownBox.instance.option('text');
      this.companyGrid.instance.filter(['name', 'contains', filter]);
    }, 1);
  }

  personGridOnInitialized(e: any) {
    this.personGrid = e.component;
    setTimeout(() => {
      let filter = this.contactDropDownBox.instance.option('text');
      this.personGrid.instance.filter(['firstname', 'contains', filter], 'or', ['lastname', 'contains', filter]);
    }, 1);
  }

  dataGridOnContentReady = (e: any) => {
    if (!e.component.isNotFirstLoad) {
      e.component.isNotFirstLoad = true;
      //wtf pls dont remove
      setTimeout(() => {
        this.ddbInstance.focus();
      }, 1);
    }
  };

  /**
   * A task result is locked once the task has left the editable states — the same condition
   * the cell editors already pass as `[readOnly]`/`[disabled]`, kept in one place so a cell
   * cannot show an editor and a read-only rendering that disagree.
   */
  isTaskResultLocked(item): boolean {
    return (
      item?.status == StatusData.IN_REVIEW.id ||
      item?.status == StatusData.DONE.id ||
      item?.status == StatusData.NOT_REQUIRED.id
    );
  }

  /**
   * Non-null only when a contact result is locked AND the contact is actually in the loaded
   * list; the cell then renders a clickable pill instead of the (read-only) dropdown.
   *
   * Resolves against `persons`/`companies` directly rather than through getPersonName/
   * getCompanyName: those return a localised "person not found" *string* for an unresolved
   * id, so they cannot tell "resolved" from "missing". The lists arrive on a different
   * promise than the tasks do, so on a slow load this would otherwise paint a pill labelled
   * "person not found" — linking to a contact that may not exist — before flipping to the
   * real name. Falling back to null keeps the editor until the contact really is known.
   *
   * Labels with `displayName`, the same field the dropdown uses as its `displayExpr`, so the
   * locked and unlocked renderings of one contact never disagree.
   */
  getContactPill(item): ContactPillValue | null {
    if (!this.isTaskResultLocked(item) || !item?.taskResult) return null;

    // Mirror the dropdown's own dataSource choice: a person, a Gesellschaft, anything else a company.
    const type = item.contactType === 'person' ? 'person' : item.contactType === 'society' ? 'society' : 'company';
    if (type === 'society' && !this.societyService.contacts$.value) this.societyService.loadContacts();
    const list = type === 'person' ? this.persons : type === 'society' ? this.societyService.contacts$.value : this.companies;
    const contact = list?.find(c => c.id == item.taskResult);

    return contact?.displayName ? { id: item.taskResult, name: contact.displayName, type } : null;
  }

  /**
   * `taskResult` is either a document id or an object carrying one; resolve both shapes to
   * the document, comparing as strings because the id types do not match across payloads.
   * Returns `{ docId }` even when the document is unknown so callers can fall back to it.
   */
  private resolveDoc(item): { docId: any; document: any } {
    if (!item || !item.taskResult) return { docId: null, document: null };

    let docId = item.taskResult;
    if (typeof docId === 'object' && docId !== null && docId.id !== undefined) {
      docId = docId.id;
    }

    return { docId, document: this.documents.find(doc => String(doc.id) === String(docId)) ?? null };
  }

  getDocName(item) {
    const { docId, document } = this.resolveDoc(item);
    if (docId == null) return '';
    if (!document) return docId; // fallback to showing the id

    return document.displayName || document.documentName || docId;
  }

  getDocFullName(item) {
    const { docId, document } = this.resolveDoc(item);
    if (docId == null) return '';
    if (!document) return docId;

    return document.documentName || docId;
  }

  getDocId(item) {
    return this.resolveDoc(item).document?.id ?? null;
  }

  isDocExternallyModified(item): boolean {
    return !!this.resolveDoc(item).document?.externallyModified;
  }

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  saveByteArray(reportName, fileType, byte) {
    let mimeType = '';

    switch (fileType) {
      case 'png':
      case 'jpeg':
        mimeType = `image/${fileType}`;
        break;
      case 'csv':
      case 'txt':
        mimeType = `text/${fileType}`;
        break;
      case 'pdf':
      case 'json':
      case 'zip':
        mimeType = `application/${fileType}`;
        break;
      case 'xls':
        mimeType = `application/vnd.ms-excel`;
        break;
      case 'ppt':
        mimeType = `application/vnd.ms-powerpoint`;
        break;
      case 'odt':
        mimeType = `application/vnd.oasis.opendocument.text`;
        break;
      case 'pptx':
        mimeType = `application/vnd.openxmlformats-officedocument.presentationml.presentation`;
        break;
      case 'xlsx':
        mimeType = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;
        break;
      case 'docx':
      case 'doc':
        mimeType = `application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
        break;
    }

    var blob = new Blob([byte], { type: mimeType });
    let link = window.URL.createObjectURL(blob);

    if (reportName == null) {
      window.open(link).focus();
      return;
    }

    const anchorElement = document.createElement('a');
    document.body.appendChild(anchorElement);
    anchorElement.style.display = 'none';

    anchorElement.href = link;
    anchorElement.download = reportName;
    anchorElement.click();

    window.URL.revokeObjectURL(link);
    anchorElement.remove();
  }

  onEditingStart(e) {
    if (e.data.type !== 'group' && e.data.status === StatusData.DONE.id && e.column.index == 4) {
      e.cancel = true;
      return;
    }
  }

  private get completedProjectWarning(): string {
    return $localize`:@@editCompletedProjectWarning:The project is complete. To make changes, set the status of the project to "Active".`;
  }

  private get pausedProjectWarning(): string {
    return this.projectStatus === ProjectStatus.INACTIVE
      ? $localize`:@@editInactiveProjectWarning:The project is inactive. To make changes, set the status of the project to "Active".`
      : $localize`:@@editCanceledProjectWarning:The project is canceled. To make changes, set the status of the project to "Active".`;
  }

  openTaskMenu(task: any): void {
    if (!task || task.type === 'group') return;

    this.taskMenuTask = task;
    this.taskMenuTarget = '#task-menu-' + task.id;
    this.taskMenuVisible = true;
  }

  onTaskMenuItemClick(e: any): void {
    const task = this.taskMenuTask;

    if (!task) return;

    this.taskMenuVisible = false;

    switch (e?.itemData?.id) {
      case 'info':
        this.getProjectTaskHistory(task.id);
        this.historyPopupVisible = true;
        break;
      case 'notifications':
        this.notificationsPopupVisible = true;
        break;
      default:
        this.getProjectTaskComments(task.id);
        this.notesPopupVisible = true;
    }
  }

  // Reopening the same task leaves projectTaskId unchanged, so the panel's own ngOnChanges does
  // not fire - this is what discards anything left staged from a cancelled visit.
  onNotificationsPopupShowing(): void {
    void this.notificationsPanel?.load();
  }

  private async confirmNotifications(): Promise<void> {
    if (await (this.notificationsPanel?.save() ?? Promise.resolve(true)))
      this.notificationsPopupVisible = false;
  }

  // Deliberately does not clear taskMenuTask - the next openTaskMenu replaces it, and the
  // notifications panel still reads it while its popup animates away.
  onTaskPopupHiding(): void {
    this.notes = null;
    this.noteFile = null;
    this.noteDescription = null;
    this.addMailMode = false;
  }

  async exportAsExcel(e) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('TaskList');

    let filter = this.taskList.instance.getCombinedFilter();
    let visibleRows: any;

    this.taskList.instance
      .getDataSource()
      .store()
      .load({ filter: filter })
      .then(result => {
        visibleRows = result;
      })
      .catch(error => {});

    this.tasks.forEach(item => {
      if (item.type == 'group' && visibleRows.findIndex(x => x.id == item.id) == -1) {
        visibleRows.push(item);
      }
    });

    visibleRows = this.sortItemsByParentAndIndex(visibleRows);
    visibleRows = this.removeChildlessGroups(visibleRows);

    visibleRows.forEach(item => {
      let taskResult = null;

      if (item.contactType) {
        switch (item.contactType) {
          case 'company':
            taskResult = this.getCompanyName(item.taskResult);
            break;
          case 'person':
            taskResult = this.getPersonName(item.taskResult);
            break;
          default:
            taskResult = item.taskResult;
            break;
        }
      }

      let row = [
        `${item.nr} | ${item.title}`,
        this.lookupStatus(item.status),
        item.role,
        item.displayType,
        this.holderName(item) || this.lookupDepartment(item.departmentId),
        taskResult,
        this.lookupPriority(item.priority),
      ];

      worksheet.addRow(row);
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      this.saveExcelBufferToFile(buffer, 'output.xlsx');
      this.loggingService.logFileExport(buffer, 'output.xlsx', {
        section: ActivitySection.PROJECT_TASKS,
        projectId: Number(this.projectId),
        siteId: this.siteId ? Number(this.siteId) : null,
      });
    } catch (error) {}
  }

  sortItemsByParentAndIndex(items) {
    function getSortedChildren(taskId) {
      return items
        .filter(item => item.parentId === taskId)
        .sort((a, b) => a.sortingIndex - b.sortingIndex)
        .flatMap(item => [item, ...getSortedChildren(item.taskId)]);
    }

    const sortedItems = items
      .filter(item => item.parentId === null)
      .sort((a, b) => a.sortingIndex - b.sortingIndex)
      .flatMap(item => [item, ...getSortedChildren(item.taskId)]);

    return sortedItems;
  }

  removeChildlessGroups(items) {
    const childrenLookup: Record<any, any> = {};

    items.forEach(obj => {
      if (obj.parentId !== null) {
        if (!childrenLookup[obj.parentId]) {
          childrenLookup[obj.parentId] = [];
        }
        childrenLookup[obj.parentId].push(obj);
      }
    });

    const hasNonGroupDescendant = (task): boolean => {
      if (task.type !== 'group') {
        return true;
      }

      const children = childrenLookup[task.taskId] || [];
      for (const child of children) {
        if (hasNonGroupDescendant(child)) {
          return true;
        }
      }

      return false;
    };

    return items.filter(obj => obj.type !== 'group' || hasNonGroupDescendant(obj));
  }

  saveExcelBufferToFile(buffer, filename) {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  getProjectTaskHistory(task: any) {
    let payload = {
      ProjectId: Number(this.projectId),
      TaskId: task,
      LogType: 'tasks',
      SearchTerm: null,
    };

    if (task.microTask) {
      payload.LogType = 'micro-tasks';
    }

    this.loggingService.getProjectTaskHistoryData(payload).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.loggingData = result.loggingItems;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    /*     let payload = {
          projectId: Number(this.projectId),
          taskId: taskId
        };

        this.loggingService.getProjectTaskHistoryData(payload).then((result) => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.loggingData = result.loggingItems;
          }
        },
          (error: any) => {
            AppGlobals.ShowErrorMessage(error);
          }); */
  }

  getWikiArticle(link) {
    if (link.includes('http://') || link.includes('https://')) {
      window.open(link, '_blank');
      return;
    }
    this.wikiService
      .getWikiArticleIdByHeaderId({
        WikiArticleRequestItem: { HeaderId: link },
      })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            let type = '';
            let headerId = '';
            //split link to get the id
            if (link.includes(':')) {
              type = link.split(':')[0];
              headerId = link.split(':')[1];
            }

            window.open(`wiki/${type}/${result.articleId}/${headerId}`, '_blank');

            this.article = result.wikiArticleItem.article;
            this.wikiArticlePopupVisible = true;
            setTimeout(() => {
              document.getElementById(link)?.scrollIntoView();
            }, 100);
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  /** Hover hint for a per-template download button — the name alone didn't say what clicking it does. */
  templateDownloadHint(template: { name: string }): string {
    return $localize`:@@downloadTemplateHint:Download ${template.name}:name:`;
  }

  /** #173: download a template that lives in the managed template library. */
  async downloadManagedTemplate(template: { id: number; name: string }) {
    try {
      const result = await this.templateManagementService.getTemplateDocumentFile({ ItemId: template.id });
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      if (result.fileResultItem?.fileBytes) {
        const bytes = this.base64ToArrayBuffer(result.fileResultItem.fileBytes);
        this.saveByteArray(result.fileResultItem.fileName ?? template.name, result.fileResultItem.fileType, bytes);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  // ---------- Automatic document creation (#148) ----------

  fillTemplateEnabled = false;
  fillTemplateVisible = false;
  fillTemplateContext: 'export' | 'task' = 'export';
  fillTemplateTaskId: number | null = null;
  fillTemplateTaskTemplates: { id: number; name: string }[] = [];
  fillTemplateAddHandler: ((doc: FillTemplateGeneratedDoc) => Promise<boolean>) | null = null;

  /** #1205: fill any configured template from the export dropdown — download only. */
  openFillTemplateForExport(): void {
    this.fillTemplateContext = 'export';
    this.fillTemplateTaskId = null;
    this.fillTemplateTaskTemplates = [];
    this.fillTemplateAddHandler = null;
    this.fillTemplateVisible = true;
  }

  /** #1207/#1578: fill one of the task's managed templates and optionally attach the result. */
  openFillTemplateForTask(item: any): void {
    this.fillTemplateContext = 'task';
    this.fillTemplateTaskId = item.id;
    this.fillTemplateTaskTemplates = item.templateDocuments ?? [];
    // "Add to task" reuses the regular task file upload; document tasks store the file as task result
    this.fillTemplateAddHandler =
      item.type === 'document' ? (doc: FillTemplateGeneratedDoc) => this.addFilledDocumentToTask(item, doc) : null;
    this.fillTemplateVisible = true;
  }

  private async addFilledDocumentToTask(item: any, doc: FillTemplateGeneratedDoc): Promise<boolean> {
    const file = fillTemplateFile(doc);

    // Same gate as uploadDocument: the upload replaces the task's previous result document, so it
    // must wait until the reviewer prompt is confirmed.
    if (item.requiresValidation === true && this.shouldPromptForValidator({ ...item, status: StatusData.IN_REVIEW.id })) {
      return new Promise<boolean>(resolve => {
        this.pendingValidatorUpload = async () => {
          const ok = await this.uploadTaskFile(item, file);
          resolve(ok);
          return ok;
        };
        this.pendingValidatorUploadCancelled = () => resolve(false);
        this.openValidatorPrompt(item);
      });
    }

    const uploaded = await this.uploadTaskFile(item, file);
    if (uploaded) this.updateStatus(item);
    return uploaded;
  }

  downloadTemplateDocument(taskId, filename) {
    this.templateService
      .getTemplateFile({ TemplateFileRequestItem: { TaskId: taskId, Filename: filename } })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            let bytes = this.base64ToArrayBuffer(result.fileResultItem.fileBytes);
            this.saveByteArray(null, result.fileResultItem.fileType, bytes);
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      )
      .catch(error => {
        // Handle error
        AppGlobals.GlobalLoaderVisible = false;
      });
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if ((this.type = 'success')) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastTwoVisible = true;
  }

  downloadCommsFile(filename) {
    this.projectTaskService.getProjectTaskCommsFile({ filename }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          let bytes = this.base64ToArrayBuffer(result.fileResultItem.fileBytes);
          this.saveByteArray(null, result.fileResultItem.fileType, bytes);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  formatDate(inputDateString) {
    const dateObject = new Date(inputDateString);

    // Extract day, month, and year from the Date object
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
    const year = dateObject.getFullYear();

    // Pad single-digit day and month with leading zeros if necessary
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    // Create the formatted date string in the dd.MM.yyyy format
    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  //#################################################

  documentDownloadPanelVisible: boolean = false;
  documentDownloadData: any = [];
  documentDownloadSelectedRowKeys: any = [];
  documentDownloadProceedButton: any = {
    text: $localize`:@@downloadDocument:Download Documents`,
    type: 'success',
    onClick: () => {
      this.handleDocumentDownloadProceed();
    },
  };
  documentDownloadCanceldButton: any = {
    text: $localize`:@@cancel:Cancel`,
    type: 'danger',
    onClick: () => {
      this.handleDocumentDownloadCancel();
    },
  };

  loadDocumentDownloadData(): void {
    this.documentDownloadSelectedRowKeys = [];
    this.documentDownloadData = [];

    // if (this.tasks[0].projectTasks == null) this.populateDocumentDownloadData([]);
    //else this.populateDocumentDownloadData(this.tasks[0].projectTasks);

    this.populateDocumentDownloadData(this.tasks);

    this.documentDownloadPanelVisible = true;
  }

  populateDocumentDownloadData(focusArray: any) {
    if (focusArray == null) return;

    focusArray.forEach((item: any) => {
      if (item.type === 'document' && item.status === StatusData.DONE.id) {
        let newItem = JSON.parse(JSON.stringify(item));
        newItem.projectTasks = null;
        this.documentDownloadData.push(newItem);
      }
      if (item.projectTasks) this.populateDocumentDownloadData(item.projectTasks);
    });
  }

  handleDocumentDownloadProceed(): void {
    let documentIdList = [];
    this.documentDownloadSelectedRowKeys.forEach((id: number) => {
      // documentIdList.push({ taskid: id, taskDocumentId: 0});

      this.documentDownloadData.forEach((tItem: any) => {
        if (tItem.taskResult != null && tItem.id == id && isNaN(tItem.taskResult) === false) {
          documentIdList.push({
            taskid: id,
            taskDocumentId: parseInt(tItem.taskResult),
          });
        }
      });
    });

    if (documentIdList.length === 0) {
      AppGlobals.ShowErrorMessage('No documents have been selected for download.');
      return;
    }

    let payload = {
      projectId: this.projectId,
      documents: documentIdList,
    };

    this.projectTaskService.getMultipleDocumentsForDownload(payload).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          if (result.hasMissingFiles === true) {
            AppGlobals.ShowErrorMessage(
              `The following files could not be downloaded. Please contact your system administrator: ${result.faultyFiles}`
            );
          }

          if (result.downloadId) this.apiFileService.downloadTempFile(result.downloadId, result.downloadFileName);
          this.handleDocumentDownloadCancel();
        }
      },
      error => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  handleDocumentDownloadCancel(): void {
    this.documentDownloadPanelVisible = false;
    this.documentDownloadSelectedRowKeys = [];
    this.documentDownloadData = [];
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  triggerTaskFileInput(e) {
    var el = document.getElementById(e);
    el.click();
  }

  triggerFileInput() {
    this.commsFileInput.nativeElement.click();
  }

  format(ratio) {
    return $localize`:@@progress:Progress` + `: ${ratio * 100}%`;
  }

  onTaskDocDrop(e, item: any) {
    e.preventDefault();

    const files = e.dataTransfer.files;
    const file = files.length > 0 ? files[0] : null;
    if (file) {
      this.uploadDocument(item.data, file);
    }
  }

  async getExportPackageData(e) {
    this.exportPackageList.instance.unselectAll();

    let groupId = e.itemData.id;

    let group = this.exportPackages.find(group => group.id == groupId);

    if (group == null) {
      AppGlobals.ShowErrorMessage($localize`The selected export group could not be found`);
      return;
    }

    // Open tasks (NOT_REQUIRED included) of the list; a list without task ids skips the check
    const openTasks = openTasksOf(group.taskIds, this.tasks);

    try {
      const preflight = await this.documentService.getExportPackagePreflight({
        ProjectId: this.projectId,
        ExportGroupId: group.id,
      });
      if (preflight?.hasError) {
        AppGlobals.ShowErrorMessage(preflight.feedback);
        return;
      }

      const gaps = buildExportGapGroups(openTasks, preflight?.groups ?? []);
      if (gaps.length > 0 && !(await this.showExportGapsPopup(gaps))) {
        return;
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
      return;
    }

    try {
      const { blob, fileName } = await this.documentService.getExportPackageData({
        ProjectId: this.projectId,
        ExportGroupId: group.id,
        TaskIds: group.taskIds,
      });

      // The success response body is the zip itself, so a JSON body means the export failed.
      if (blob.type.includes('json')) {
        const failure = JSON.parse(await blob.text());
        AppGlobals.ShowErrorMessage(failure?.feedback ?? $localize`The export package could not be created`);
        return;
      }

      this.downloadBlob(blob, fileName || 'Export.zip');
      this.handleDocumentDownloadCancel();
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  private downloadBlob(blob: Blob, fileName: string): void {
    const objectUrl = URL.createObjectURL(blob);
    const anchorElement = document.createElement('a');
    anchorElement.style.display = 'none';
    anchorElement.href = objectUrl;
    anchorElement.download = fileName;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    anchorElement.remove();
    URL.revokeObjectURL(objectUrl);
  }

  exportGapsVisible = false;
  exportGaps: GapGroup[] = [];
  exportGapsTitle = '';
  private exportGapsResolve: (ok: boolean) => void;
  exportGapsButtons: PopupButton[] = [
    { text: $localize`:@@cancel:Cancel`, type: 'secondary', onClick: () => this.exportGapsResolve?.(false) },
    { text: $localize`:@@exportAnyway:Export anyway`, type: 'primary', onClick: () => this.exportGapsResolve?.(true) },
  ];

  showExportGapsPopup(gaps: GapGroup[]): Promise<boolean> {
    this.exportGaps = gaps;
    this.exportGapsTitle = $localize`:@@exportGapsTitle:Export: ${gaps.reduce((n, g) => n + g.count, 0)}:count: open items`;
    this.exportGapsVisible = true;
    return new Promise(resolve => {
      this.exportGapsResolve = ok => {
        this.exportGapsResolve = null;
        resolve(ok);
      };
    });
  }

  onExportGapsHiding() {
    // Closing via X / Escape counts as cancel (no-op after a button already resolved)
    this.exportGapsResolve?.(false);
  }

  showExportPackagePopup(arg0: null) {}

  canApprove() {
    return AppGlobals.UserPermissions.canValidate;
  }

  /** #4994: held by me, or by my department (assignedDepartmentId already folds in the role). */
  isMine(t): boolean {
    return (
      t.assignedUserEmail === AppGlobals.LoggedInUserData.email ||
      (this.myDepartmentId != null && t.assignedDepartmentId === this.myDepartmentId)
    );
  }

  lookupDepartment(id) {
    return this.departments?.find(department => department.id == id)?.name ?? '';
  }

  lookupUser(email) {
    return this.users?.find(user => user.emailAddress == email)?.displayName;
  }

  /**
   * #4993: who effectively holds the task (the API already folds in the role slot): a department
   * name or a person. Empty when nobody does, so callers fall back to the role name.
   */
  holderName(item): string {
    if (item.assignedDepartmentId != null)
      return item.assignedDepartmentName ?? this.lookupDepartment(item.assignedDepartmentId);
    return item.assignedUserEmail ? (this.lookupUser(item.assignedUserEmail) ?? item.assignedUserEmail) : '';
  }

  lookupPriority(priority) {
    switch (priority) {
      case 1:
        return $localize`:@@high:High`;
      case 2:
        return $localize`:@@medium:Medium`;
      case 3:
        return $localize`:@@low:Low`;
      default:
        return '';
    }
  }

  lookupStatus(status) {
    return getStatusOption(status);
  }

  formatNumber(e: any) {
    if (e != undefined) {
      // #4355: de-DE Intl default caps at 3 fraction digits; raise the number
      // task field's cap to 6.
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 6 }).format(e);
    }
  }

  getTaskCount(type) {
    // Called once per toolbar pill on every change-detection pass (i.e. on every
    // keystroke in the search box). Build the per-status counts once and serve
    // them from cache instead of re-scanning the whole task list each time.
    if (this.taskCountCache == null) {
      this.rebuildTaskCountCache();
    }
    if (type == null) return this.taskCountCache.all;
    return this.taskCountCache[type] ?? 0;
  }

  // Scans the same subset applyFilter() would show with no status pill selected
  // (search + "Meine Aufgaben" + "Aktuelle Aufgaben"), so pill counts reflect the
  // active filters instead of the whole unfiltered task list. The status pill
  // itself is deliberately excluded here — pills need their own count *within*
  // that subset, not a count that already excludes everything but themselves.
  private rebuildTaskCountCache(): void {
    const cache: { all: number; [status: string]: number } = { all: 0 };
    const taskFilterValue = this.taskFilterValue();
    const myTasksOn = taskFilterValue.includes('myTasks');
    const currentTasksOn = taskFilterValue.includes('currentTasks');
    const search = this.searchValue ? String(this.searchValue).toLowerCase() : null;
    for (const t of this.tasks) {
      if (t.type == 'group') continue;
      if (myTasksOn && !this.isMine(t)) continue;
      if (currentTasksOn && !t.isTaskPackageCurrentOrOverdue) continue;
      if (search && !t.title?.toLowerCase().includes(search)) continue;
      cache.all++;
      cache[t.status] = (cache[t.status] ?? 0) + 1;
    }
    this.taskCountCache = cache;
  }

  // Force the pill counts to be recomputed on next read. Call whenever tasks are
  // (re)loaded or any task's status changes.
  private invalidateTaskCountCache(): void {
    this.taskCountCache = null;
  }

  showContractSelectorPopup(contractTarget: any) {
    this.contractSelectorPopupVisible = true;
    this.setPopupReturnTarget(contractTarget);
  }

  getContractDesignation(id) {
    return this.contractService.getContractDesignationById(id);
  }

  goToContractDetails(arg0: any) {
    this.contractService.setPreviousUrl(this.router.url);
    this.router.navigate(['contracts', 'edit', arg0]);
  }

  addNewContractToTask(contractTarget: any) {
    this.router.navigate(['contracts', 'addToTask', this.contractTarget.id]);
  }

  onContractSelected($event: any) {
    const item = this.targetItem;
    const before = { status: item.status, isCompleted: item.isCompleted };
    item.taskResult = $event.id;
    item.status = item.requiresValidation === true ? StatusData.IN_REVIEW.id : StatusData.DONE.id;
    item.isCompleted = true;
    // The designation label reads the linked-contracts cache, which does not hold a newly picked one yet.
    this.loadLinkedContracts([Number($event.id)]);
    this.saveOrPromptForValidator(item, before);
  }
}
